import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const DataPage = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');

  const dataCategories = [
    {
      id: 'overview',
      title: 'Overview',
      description: 'Comprehensive overview of critical minerals markets and key performance indicators',
      thumbnail: 'images/data_page_thumbnails/overview_kpi.jpg',
      route: '/overview'
    },
    {
      id: 'supply-markets',
      title: 'Supply & Markets',
      description: 'Analyze critical minerals supply chains, market dynamics, and trade flows',
      thumbnail: 'images/data_page_thumbnails/supply_market.jpg',
      route: '/supply-markets'
    },
    {
      id: 'partner-risk',
      title: 'Partners & Risk',
      description: 'Assess geopolitical risks and dependencies across supply chain partners',
      thumbnail: 'images/data_page_thumbnails/partner_risk.jpg',
      route: '/partners-risk'
    },
    {
      id: 'policy-intelligence',
      title: 'Policy & Intelligence',
      description: 'Monitor policy developments, regulations, and government initiatives',
      thumbnail: 'images/data_page_thumbnails/policy_intelligence.jpg',
      route: '/policy-intelligence'
    },
    {   
      id: 'methodology',
      title: 'Methodology',
      description: 'Research methods, data sources, and analytical frameworks',
      thumbnail: 'images/data_page_thumbnails/methodology.jpg',
      route: '/methodology'
    }
  ];

  const filteredCategories = dataCategories.filter(category =>
    category.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    category.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleCategoryClick = (route) => {
    navigate(route);
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header */}
      <div className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
        <div className="container mx-auto px-6 py-8">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
            Research Data
          </h1>
          <p className="text-lg text-gray-600 dark:text-gray-300 mb-6">
            Search for specific insights, or browse all our data by area and topic.
          </p>
          
          {/* Search Bar */}
          <div className="relative max-w-2xl">
            <input
              type="text"
              placeholder="Search for a topic, chart or analysis..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-4 py-3 pl-12 pr-4 text-gray-900 dark:text-white bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            <svg className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-6 py-8">
        {/* All Areas Section */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-6">
            All areas of research
          </h2>
          
          {/* Data Categories Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredCategories.map((category) => (
              <div
                key={category.id}
                onClick={() => handleCategoryClick(category.route)}
                className="bg-white dark:bg-gray-800 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 cursor-pointer group"
              >
                {/* Thumbnail */}
                <div className="relative overflow-hidden rounded-t-lg">
                  <img
                    src={category.thumbnail}
                    alt={category.title}
                    className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-200"
                  />
                </div>
                
                {/* Content */}
                <div className="p-4">
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors">
                    {category.title}
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
                    {category.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataPage;
